import React, { useContext, useEffect, useState } from "react";
import * as r from "../../../../constants/routes";
import classes from "./GamesScreen.module.scss";
import { useNavigate } from "react-router";
import UserTrainingContext from "../../../../context/userTrainingContext";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../components/Spinner";
import RoundButton from "../../../../components/Buttons/RoundButton";
import {
  faTimes,
  faClock,
  faRedo,
  faForward,
  faBackward,
  faCheck,
  faFlagCheckered,
  faTrophy,
  faHeartBroken,
} from "@fortawesome/free-solid-svg-icons";
import { setAnalyticsPlayGame } from "../../../../helpers/analyticsHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { integer } from "aws-sdk/clients/cloudfront";
import SessionContext from "../../../../context/sessionContext";
import { API_USER_SMART } from "../../../../constants/api";
import useFetch from "../../../../hooks/useFetch";

export default function GamesScreen() {
  const tContext = useContext(UserTrainingContext);
  const cSession = useContext(SessionContext);
  const { game_url, game_name, setGameUrl } = tContext ?? {};
  const { t } = useTranslation();
  const history = useNavigate();
  const [controlMessege, setControlMessege] = useState<boolean>(true);
  const [scoreInfo, setScoreInfo] = useState(<></>);
  const [clickMask, setclickMask] = useState(<></>);
  const [clickMaskActive, setclickMaskActive] = useState(false);
  const [_content, _setContent] = useState(<Spinner center />);
  const [showScore, setshowScore] = useState(false);
  const [objStructure, setobjStructure] = useState(Object);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [dataMsg, setdataMsg] = useState<any>();
  const [scoreCounter, setscoreCounter] = useState(0);
  const [finalScore, setfinalScore] = useState(0);
  const [ActionButton, setActionButton] = useState<any>();
  const [userInfo, setuserInfo] = useState<any>();

  async function getUserSmartInfo(session: any) {
    try {
      const response = await fetch(API_USER_SMART, {
        method: 'GET',
        headers: {
          userauthorization: session.user.token,
        },
      })
      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }
      const result = (await response.json());
      setuserInfo(result)
    } catch (err: any) {
      console.log(err.message);
    }
  }


  function getStatus(status: string, progress: integer) {
    let statusIcon: any;
    let colorStatus: any;

    //deixei aqui para futuramente se tivermos botões diferentes pra cada estado ser facilmente alterado]
    // edit** tava dando loop no codigo vou deixar aqui pra referencia
    // setActionButton(
    // <RoundButton
    //   title={t("global.continue_train")}
    //   className={classes.BtnConfirm}
    //   onClick={() => history("/")}>
    //   {t("global.continue_train")}
    // </RoundButton>)

    if (progress % 5 == 0 && progress > 0) {
      status = "CHECKPOINT";
    }

    switch (status) {
      case "CONTINUE": {
        statusIcon = faForward;
        colorStatus = "#2dbf64ff";
        break;
      }
      case "DONE": {
        statusIcon = faTrophy;
        colorStatus = "#2dbf64ff";
        break;
      }
      case "CHECKPOINT": {
        statusIcon = faFlagCheckered;
        colorStatus = "#2dbf64ff";
        break;
      }
      case "REPEAT": {
        statusIcon = faRedo;
        colorStatus = "#f9d012ff";
        break;
      }
      case "GO_BACK_NIVEL": {
        statusIcon = faBackward;
        colorStatus = "#bf2d2dff";
        break;
      }
      case "GO_BACK_INIT": {
        statusIcon = faHeartBroken;
        colorStatus = "#bf2d2dff";
        break;
      }
      case "WRONG_TRY_AGAIN": {
        statusIcon = faRedo;
        colorStatus = "#bf2d2dff";
        break;
      }
      default: {
        break;
      }
    }

    const statusBuild = (
      <span className={classes.ml5}>
        <b>{t("global." + status + "_IA")}</b>
        <FontAwesomeIcon
          icon={statusIcon}
          color={colorStatus}
          className={classes.statusIcon}
        />
      </span>
    );

    return statusBuild;
  }

  useEffect(() => {
    if (scoreCounter < finalScore) {
      const interval = setInterval(() => {
        setscoreCounter(scoreCounter + 1);
      }, 30);
      return () => clearInterval(interval);
    }
  }, [scoreCounter, finalScore]);

  useEffect(() => {
    if (clickMaskActive) {
      setclickMask(<div className={classes.clickMask}></div>);
    }
  }, [clickMaskActive]);

  useEffect(() => {
    if (objStructure && objStructure.score) {
      setInterval(() => {
        setfinalScore(objStructure.score);
      }, 2000);
    }
  }, [objStructure]);

  useEffect(() => {
    if (showScore && objStructure && !dataMsg?.error) {
      setScoreInfo(
        <div className={classes.GameScoreContainer}>
          <div className={classes.GameScore + " " + classes.animationShowModal}>
            <div className={classes.GameScoreTitle}>
              <p>{t("global.saved")}</p>
            </div>
            <div className={classes.GameCardContainer}>
              <div className={classes.GameInfoScoreContainer}>
                <p className={classes.GameInfoScore}>{scoreCounter}</p>
                <p>{t("global.score")}</p>
              </div>
              <div className={classes.GameInfosContainer}>
                <p className={classes.GameNameTitle}>{objStructure.gameName}</p>
                <p>
                  {t("global.trilha")}:
                  <span className={classes.ml5}>{t("trilhas." + objStructure.label)}</span>
                </p>
                <div className={classes.gridx2}>
                  <span>
                    {t("global.level")}:
                    <span className={classes.ml5}>{objStructure.nivel}</span>
                  </span>
                  <span className={classes.GameTime}>
                    <FontAwesomeIcon icon={faClock} /> {objStructure.time}
                  </span>
                  <span> {t("global.status")}:</span>
                  <span>
                    {getStatus(objStructure.status, objStructure.new_progress)}
                  </span>
                </div>
              </div>
              <div className={classes.buttonContainer}>
                {/* {ActionButton} */}
                <RoundButton
                  title={t("global.continue_train")}
                  className={classes.BtnConfirm}
                  onClick={() => {
                    const actualUrl = window.location.href;
                    const categories = ["agilidade-mental", "foco", "memória", "escuta-ativa"]
                    const hasCategory = categories.some(category => actualUrl.includes(category));
                    const match = actualUrl.match(/\/([^/]+)\/jogo/);
                    const url = match ? match[1] : "";
                    if (cSession?.is_smart_user) history("/smart")
                    else if (!cSession?.is_smart_user) history(hasCategory ? `${r.R_U_HOME}/${url}` : r.R_U_HOME);
                    else history("/")
                  }}
                >
                  {t("global.continue_train")}
                </RoundButton>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (
      (showScore && dataMsg?.error) ||
      (!isOnline && clickMaskActive)
    ) {
      setScoreInfo(
        <div className={classes.GameScoreContainer}>
          <div className={classes.GameScore + " " + classes.animationShowError}>
            <div className={classes.GameScoreTitle}>
              <p>{t("infos.fail_save")}</p>
            </div>
            <div className={classes.GameCardContainerError}>
              <p className={classes.errorInfo}>
                {t("infos.error_saving_score")}
              </p>
              <p className={classes.errorInfo}>{t("infos.error_persist")}</p>
              <a className={classes.errorInfo}>{t("infos.support_email")}</a>
              <div className={classes.buttonContainer}>
                {/* {ActionButton} */}
                <RoundButton
                  title={t("global.continue_train")}
                  className={classes.BtnConfirm}
                  onClick={() => history("/")}
                >
                  {t("global.continue_train")}
                </RoundButton>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }, [
    showScore,
    objStructure,
    clickMaskActive,
    dataMsg,
    scoreCounter,
    ActionButton,
    isOnline,
  ]);


  useEffect(() => {
    if (controlMessege) {
      window.onmessage = (event: MessageEvent) => {
        if (event.data.message && game_url && game_url.includes(event.origin)) {
          try {
            setdataMsg(JSON.parse(atob(event.data.message)));
          } catch (e) {
            setdataMsg(event.data);
          }
        }
      };
    }
  }, [controlMessege]);

  useEffect(() => {
    if (cSession.is_smart_user && cSession.user) {
      if (!userInfo)
        getUserSmartInfo(cSession);
    }
  }, [dataMsg, cSession]);

  useEffect(() => {
    if (userInfo && userInfo.journey_code != 4) {
      if (
        dataMsg &&
        dataMsg?.data?.layoutName &&
        dataMsg.data.layoutName == "ScoreScreen"
      ) {
        setclickMaskActive(true);
      }
      if (dataMsg && !dataMsg.event) {
        {
          setobjStructure(dataMsg);
          setControlMessege(false);
          setshowScore(true);
        }
      }
    }
  }, [userInfo, dataMsg])

  useEffect(() => {
    if (game_name) setAnalyticsPlayGame({ name: game_name });
  }, [game_name]);

  useEffect(() => {
    function onlineHandler() {
      setIsOnline(true);
    }

    function offlineHandler() {
      setIsOnline(false);
    }

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    return () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    };
  }, []);

  function gobackScreen() {
    document.body.classList.remove(classes.hideScroll);
    const actualUrl = window.location.href;
    const categories = ["agilidade-mental", "foco", "memória", "escuta-ativa"]
    const hasCategory = categories.some(category => actualUrl.includes(category));
    const match = actualUrl.match(/\/([^/]+)\/jogo/);
    const url = match ? match[1] : "";
    if (cSession?.is_smart_user) history("/smart")
    else if (!cSession?.is_smart_user) history(hasCategory ? `${r.R_U_HOME}/${url}` : r.R_U_HOME);
    else history("/")
  }

  useEffect(() => {
    if (game_url) {
      document.body.classList.add(classes.hideScroll);
      _setContent(
        <>
          {tContext.game_url && (
            <div className={classes.GameModalArea}>
              <div className={classes.GameModal}>
                {clickMask}
                <embed src={tContext.game_url} />
                <RoundButton
                  title={t("global.close")}
                  faIcon={faTimes}
                  className={classes.BtnClose}
                  onClick={() => gobackScreen()}
                />
                {scoreInfo}
              </div>
            </div>
          )}
        </>
      );
    } else {
      history(r.R_A_ROOT);
    }
  }, [game_url, scoreInfo, clickMask]);

  return _content;
}
